













import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop } from "vue-property-decorator";
import { EventType, EventInjectionReason } from "@/models/event";

const availableTypes: {
  [key in EventType]: {
    icon: string;
    color: string;
    subtypeColor?: {[key: string]: string};
  }
} = {
  [EventType.Bleeding]: {
    color: "#af2020",
    icon: "fas fa-tint"
  },
  [EventType.Injection]: {
    color: "#57C543",
    subtypeColor: {
      [EventInjectionReason.Bleeding]: "#af2020"
    },
    icon: "fi fi-injection-syringe"
  },
  [EventType.Inspection]: {
    color: "#6074ED",
    icon: "fi fi-stethoscope"
  },
  [EventType.MissedInjection]: {
    color: "#4a4a4a",
    icon: "fi fi-injection-syringe"
  },
  [EventType.Note]: {
    color: "#4a4a4a",
    icon: "ion-ios-bookmarks"
  },
  [EventType.Operation]: {
    color: "#6074ED",
    icon: "fi fi-doctor"
  },
  [EventType.Physiotherapy]: {
    color: "#E5D33E",
    icon: "accessibility"
  },
  [EventType.Sport]: {
    color: "#E5D33E",
    icon: "ion-ios-fitness"
  },
  [EventType.Visit]: {
    color: "blue",
    icon: "fi fi-doctor"
  }
};

@Component({})
export class EventTypeIcon extends Vue {
  @Model()
  @Prop({ required: true })
  value!: EventType;

  @Prop({ required: false })
  subtype!: any;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  dark!: boolean;

  @Prop({ default: false })
  dense!: boolean;

  @Prop({ default: "" })
  color!: string;

  get iconColor() {
    if (!!this.color) {
      return this.color;
    }

    const match = availableTypes[this.value];
    if (!!this.subtype && match.subtypeColor && match.subtypeColor[this.subtype]) {
      return match.subtypeColor[this.subtype];
    }
    return (availableTypes[this.value] || { color: "#000000" }).color;
  }

  get icon() {
    return (availableTypes[this.value] || { icon: "default" }).icon;
  }
}

export default EventTypeIcon;
